import fieldErrorMesseages from '@/cfg/error.json';
import debounce from 'debounce';
import {arrayFindInArray, capitalize, secToMicrosec, millisecToMicrosec} from '@/js/helper.js';
import jsonpath from 'jsonpath';
import requests from '@/js/requests';
import {simService} from "@/api";

function getCheckboxRules(fieldAttrInput, templateContent, field) {
    // no rules when disabled
    if ((typeof templateContent != 'undefined' && typeof templateContent.disableAllInputs != 'undefined' &&
            templateContent.disableAllInputs === true) ||
        (typeof fieldAttrInput != 'undefined' && typeof fieldAttrInput.disabled != 'undefined' &&
            fieldAttrInput.disabled === true)) {
        return [];
    }
    let rules = [];
    if (typeof fieldAttrInput != 'undefined' && typeof fieldAttrInput.class != 'undefined') {
        let classes = fieldAttrInput.class;
        if (classes.indexOf('required') > -1) {
            rules.push(v => !!v || '');
        }

        if (classes.indexOf('requireOne') > -1) {
            rules.push(() => validateOneChecked(templateContent, field) || '');
        }
    }
    return rules;
}

function validateOneChecked(templateContent, field) {
    if (typeof templateContent.valueLine[field] == 'undefined') {
        return false;
    }
    console.log(templateContent.valueLine[field].length, templateContent.valueLine[field].length > 0);
    return templateContent.valueLine[field].length > 0;
}

function getSelectRules(fieldAttrInput, templateContent,value) {
    // no rules when disabled
    if (templateContent?.disableAllInputs || fieldAttrInput?.disabled) {
        return [];
    }
    let rules = [];
    if (fieldAttrInput?.class) {
        let classes = fieldAttrInput.class;
        if (classes.indexOf('required') > -1) {
            rules.push(v => !!v || v === '0' || '');
        }

        if (classes.indexOf('checkVariables') > -1 && classes.indexOf('addable') > -1) {
            if (!value) {
                rules.push(() => value || '');
            }else if (!/\${[\w:.]+}/.test(value) && !fieldAttrInput?.allowed.includes(value)) {
                rules.push(() => 'Wrong variable syntax');
            }
        }
    }
    return rules;
}

function getRules(fieldAttrInput, templateContent, field, caller) {
    // no rules when disabled
    if ((typeof templateContent != 'undefined' && typeof templateContent.disableAllInputs !== 'undefined' &&
            templateContent.disableAllInputs === true) ||
        (typeof fieldAttrInput != 'undefined' && typeof fieldAttrInput.disabled != 'undefined' &&
            fieldAttrInput.disabled === true)

    ) {
        return [];
    }
    let rules = [];

    if (typeof fieldAttrInput != 'undefined' && typeof fieldAttrInput.class != 'undefined') {
        let classes = fieldAttrInput.class;
        if (classes.indexOf('required') > -1) {
            rules.push(v => !!v || '');
        }
        if (classes.indexOf('IPAddress') > -1) {
            rules.push(v => validateIP(v) || fieldErrorMesseages.invalidIP);
        }
        if (classes.indexOf('numberOrVariable') > -1) {
            rules.push(v => isNumeric(v) || !!v && /^\$\{(?:\w+|\w+:\w+)\}$/.test(v.toString())
                || fieldErrorMesseages.notANumberOrVariable);
        } else if (classes.indexOf('number') > -1) {
            rules.push(v => isNumeric(v) || fieldErrorMesseages.notAnumber);
        }
        if (classes.indexOf('digits') > -1) {
            rules.push(v => isNumeric(v) || fieldErrorMesseages.notAnumber);
        }
        if (classes.indexOf('IPV4IPV6Domain') > -1) {
            rules.push(v => validateIPV4andIPV6(v) || validateDomain(v) || fieldErrorMesseages.invalidIPV4IPV6Domain);
        }
        if (classes.includes('validatePingInterval')) {
            rules.push(getRequiredRule());
            rules.push(getRuleForPossibleUnits(['s', 'ms', 'µs']));
            rules.push(getPingIntervalRule());
        }
        if (classes.includes('validateHexByte')) {
            rules.push(getRequiredRule());
            rules.push(getHexByteRule());
        }
        if (classes.includes('validatePort')) {
            rules.push(getRequiredRule());
            rules.push(getPortRule());
        }

        if (classes.indexOf('hex') > -1) {
            rules.push(v => validateHex(v) || fieldErrorMesseages.hexString);
        }

        if (classes.indexOf('notOnlyNumber') > -1) {
            rules.push(v => notOnlyNumberChecker(v) || fieldErrorMesseages.notOnlyNumber);
        }

        if (classes.indexOf('plusPhone') > -1) {
            rules.push(v => plusPhoneChecker(v) || fieldErrorMesseages.plusPhoneChecker);
        }

        if (classes.indexOf('plusNotFollowedByZero') > -1) {
            rules.push(v => plusNotFollowedByZero(v) || fieldErrorMesseages.plusNotFollowedByZero);
        }
        //false is trigger the error !
        if (classes.indexOf('MSISDN-Checker') > -1) {
            rules.push(v => MSISDNChecker(v) || fieldErrorMesseages.plusPhoneChecker);
        }

        if (classes.indexOf('fullNameCheckFunction') > -1) {
            rules.push(v => fullNameCheckFunction(v), function (v) {
                let value = v;
                let index = value.lastIndexOf(' ');
                let firstName = value.substring(0, index);
                let lastName = value.substring(index);

                if (firstName === '' || lastName === '') {
                    return 'Please enter First Name and Last Name separated by space';
                } else if (firstName.length > 100) {
                    return 'First Name cannot be more than 100';
                } else if (lastName.length > 100) {
                    return 'Last Name cannot be more than 100';
                } else {
                    return 'First Name and Last Name seperated by space';
                }

            });

        }

        if (classes.indexOf('IPV4OrIPV6OrDNS') > -1) {
            rules.push(v => validateIPV4andIPV6(v) || validateDomainNameOnly(
                v) || fieldErrorMesseages.invalidIPV4IPV6DomainName);
        }

        if (classes.indexOf('jsonPathCheck') > -1) {
            rules.push(v => validateJsonPath(v) || fieldErrorMesseages.invalidJsonPath);
        }

        if (classes.indexOf('xPathCheck') > -1) {
            rules.push(v => validateXPath(v) || fieldErrorMesseages.invalidXPath);
        }
        if (classes.indexOf('xPathorVariable') > -1) {
            rules.push(v => validateXPath(v) || // validateIdClass(v) ||
                validateVariable(v) || 'not a variable or XPATH format');
        }

        if (classes.indexOf('IPV4IPV6') > -1) {
            rules.push(v => validateIPV4andIPV6(v) || fieldErrorMesseages.invalidIPV4IPV6);
        }

        if (classes.indexOf('IPDomain') > -1) {
            rules.push(v => validateIP(v) || validateDomain(v) || 'Must be a Valid IP or Domain');
        }

        if (classes.indexOf('IP6aDomainaVariable') > -1) {
            rules.push(v => validateIPV6(v) || validateDomain(v) || validateVariable(
                v) || 'Must be a Valid IPV6 or Domain or Variable');
        }

        if (classes.indexOf('IPV6WithDomainVariableProtocolPort') > -1) {
            rules.push(v => validateIPV6WithProtocol(v) || validateSpecialDomain(v) || validateDomain(v) || validateVariable(
                v) || 'Must be a Valid IPV6 or Domain or Variable');
        }

        if (classes.indexOf('IPV4WithDomainVariableProtocolPort') > -1) {
            rules.push(v => validateIPWithProtocol(v) || validateSpecialDomain(v) || validateDomain(v) || validateVariable(
                v) || 'Must be a Valid IPV4 or Domain or Variable');
        }

        if (classes.indexOf('IPaDomainaVariable') > -1) {
            rules.push(v => validateIP(v) || validateDomain(v) || validateVariable(
                v) || 'Must be a Valid IPV4 or Domain or Variable');
        }

        if (classes.indexOf('sipAddress') > -1) {
            rules.push(v => validateSIP(v) || 'Must be a Valid Address!');
        }

        if (classes.indexOf('checkURI') > -1) {
            rules.push(v => validateURI(v) || fieldErrorMesseages.invalidURI);
        }

        if (classes.indexOf('testConditionInput') > -1) {
            rules.push(v => testConditionInputChecker(v) || 'Syntax Error in condition');
        }
        if (classes.indexOf('checkMSISDNCID') > -1) {
            rules.push(v => validateMSISDNCustomerID(
                v) || 'The Subscriber Should be Number or Customer ID should be Number # Alphabet ');
        }
        if (classes.indexOf('fileInputChecker') > -1) {
            rules.push(v => validateFileInput(v, templateContent) || fileUploadMessage(v, templateContent));
        }
        if (classes.indexOf('fileInputSizeCheck') > -1) {
            rules.push(v => validateFileSizeInput(v, templateContent) || fileSizeUploadMessage(v, templateContent));
        }

        if (classes.indexOf('checkRegexVariable') > -1) {
            rules.push(v => checkRegexVariable(v) || ' Input should be a valid Regex ');
        }

        if (classes.indexOf('numericDotCheck') > -1) {
            rules.push(v => numericAndDotAllowed(v) || ' Only Numeric value  with "Dot" Allowed ,No "Comma" Allowed ');
        }

        if (classes.indexOf('validChar') > -1) {
            rules.push(v => /^$|^[A-Za-z\d=!\-@._*,$]*$/.test(v) // consists of only these
                || fieldErrorMesseages.invalidChar);
        }

        if (classes.indexOf('alphanumeric') > -1) {
            rules.push(v => /^\w+$/.test(v) // consists of only these
                || fieldErrorMesseages.invalidAlphanumeric);
        }

        if (classes.indexOf('atcommand') > -1) {
            rules.push(v => /^[\w=+#"\s?]+$/.test(v) // consists of only these
                || fieldErrorMesseages.invalidATCommand);
        }

        if (classes.indexOf('uppercheck') > -1) {
            rules.push(v => /^$|[A-Z]/.test(v) // has a uppercase letter
                || fieldErrorMesseages.noUpperCase);
        }

        if (classes.indexOf('lowercheck') > -1) {
            rules.push(v => /^$|[a-z]/.test(v) // has a lowercase letter
                || fieldErrorMesseages.noLowerCase);
        }

        if (classes.indexOf('oneDigit') > -1) {
            rules.push(v => /^$|\d/.test(v) // has a digit
                || fieldErrorMesseages.noDigit);
        }
        if (classes.indexOf('onlyAsciiAlphabet') > -1) {
            rules.push(v => validateAsciiAlphabet(v) || fieldErrorMesseages.onlyAsciiAlphabet);
        }

        if (classes.indexOf('validateNewCaptcha') > -1) {
            rules.push(v => validateNewCaptcha(v) || fieldErrorMesseages.reCaptcha);
        }

        if (classes.indexOf('evalValue') > -1) {
            rules.push(v => v.indexOf('EVAL:') === 0 || fieldErrorMesseages.reCaptcha);
        }

        if (classes.indexOf('validateCases') > -1) {
            rules.push(v => validateCases(v, templateContent) || 'shouldnt be shown');
        }

        if (classes.indexOf('userExists') > -1) {
            rules.push(v => checkUserExists(v, templateContent, field, caller) || 'field must be unique');
        }

        if (classes.indexOf('unique') > -1) {
            rules.push(v => checkUnique(v, templateContent, field, caller, rules) || 'field must be unique');
        }

        if (classes.indexOf('vendorUniqueDomain') > -1) {

            rules.push(v => vendorUniqueDomain(v, templateContent, field, caller, rules));
        }
        if (classes.indexOf('uniquOrganisation') > -1) {

            rules.push(v => uniqueOrganisation(v, templateContent, field, caller, rules));
        }
        if (classes.indexOf('checkTagSyntax') > -1) {
            rules.push(v => callTagValidation(v,caller,rules));
        }
        if (classes.indexOf('noSpace') > -1) {
            rules.push(v => !/(\s)/.test(v) // has a digit
                || fieldErrorMesseages.noSpace);
        }
        if (classes.indexOf('checkPassword') > -1) {
            rules.push(v => checkConfirmPassCode(v, templateContent) || fieldErrorMesseages.confirmPassCodeError);
        }
        if (classes.indexOf('password') > -1) {
            rules.push(v => passwordControl(v) || fieldErrorMesseages.minEight);
        }

        if (classes.indexOf('passwordSafe') > -1) {
            rules.push(v => checkPasswordSafe(v, templateContent, field, caller, rules) || 'Password Should be safe');
        }
        if (classes.indexOf('emailCheck') > -1) {
            rules.push(v => checkEmail(v, templateContent, field, caller, rules) || 'Email must be valid');
        }
        // misspelled on purpose. do not change!
        if (classes.indexOf('uniquEmail') > -1) {
            rules.push(v => checkUniqueEmail(v, templateContent, field, caller, rules) || 'Email must be valid');
        }
        if (classes.indexOf('checkTypeMaxValue') > -1) {
            rules.push(v => checkTypeMaxValue(v,
                templateContent) || 'Max acceptable value is ' + templateContent.fields.content.AvgMaxNumber);
        }
        if (classes.indexOf('digitalVariable') > -1) {
            rules.push(v => checkNumberVariable(v) || 'Must be number or variable');
        }
        if (classes.indexOf('mcc-mnc') > -1) {
            rules.push(v => checkMccMnc(v) || 'Must be between 5 and 6 digit');
        }
        if (classes.indexOf('multiLineIPsWithVariables') > -1) {
            rules.push(v => multiLineIPs(v) || 'must be list of IPs');
        }
        if (classes.indexOf('multiLineIPwithDomainsWithVariables') > -1) {
            rules.push(v => checkMultiLineIPwithDomainsWithVariables(v) || 'must be list of IPs or domains');
        }

        if (/\s?url\s?/.test(classes)) {
            rules.push(
                v => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/
                    .test(v) || 'Invalid URL.');
        }
        if (classes.indexOf('customMinMax') > -1) {
            let allowed = fieldAttrInput.allowedFrom ? fieldAttrInput.allowedFrom:"";
            rules.push(v => customMinMax(v, fieldAttrInput) || 'Enter between '+allowed+' to '+fieldAttrInput.max);
        }

    } //End

    if (typeof fieldAttrInput != 'undefined' && typeof fieldAttrInput.max != 'undefined') {
        rules.push(v => v <= parseInt(fieldAttrInput.max) || 'Not more than ' + fieldAttrInput.max);
    }
    if (typeof fieldAttrInput != 'undefined' && typeof fieldAttrInput.min != 'undefined') {
        rules.push(v => v >= parseInt(fieldAttrInput.min) || 'Not less than ' + fieldAttrInput.min);
    }
    return rules;
}

function customMinMax(v,fieldAttrInput){  //In between,min and max rang, certain values is not allowed!
   return !fieldAttrInput.notAllowed.includes(parseInt(v))? true:false; //not allowed 004
 }
function checkMultiLineIPwithDomainsWithVariables(v = '') {
    let check = v.split('\n').some(ele => {
        return !(validateIPV4andIPV6(ele) || validateDomainNameOnly(ele) || validateVariable(ele));
    });
    return !check;
}

function multiLineIPs(v = '') {

    let check = v.split('\n').some(ele => {
        return !(validateIPV4andIPV6(ele) || validateVariable(ele));
    });
    return !check;

}

function checkNumberVariable(v = '') {
    // @ts-ignore
    return (isNumeric(v) && v >= 1) || validateVariable(v);

}

function checkMccMnc(v = '') {
    let result = false;
    if (v.length >= 5 && v.length <= 6) {
        result = true;
    }
    return result;
}

function validateAsciiAlphabet(value) {
    let regex = /^[a-zA-Z]+$/;
    return value === '' || value.match(regex) != null;
}

function fileUploadMessage(value, templateContent) {
    let errorMessage = '';
    if (typeof templateContent.fields.fileName.accept != 'undefined') {
        let stringAccept = templateContent.fields.fileName.accept;
        let newString = stringAccept.split('.').join('');
        errorMessage = 'Accept only ' + newString + ' file extensions!';
    }
    return errorMessage;
}

function fileSizeUploadMessage(value, templateContent) {
    let errorMessage = '';
    if (typeof templateContent.fields.fileName.maxSize != 'undefined') {
        let allowedSize = templateContent.fields.fileName.maxSize;
        let currentSize = value['size'];
        if (currentSize > allowedSize) {
            errorMessage = 'The file size should not be more than 2 MB!';
        }
    }
    return errorMessage;
}

function validateFileInput(value, templateContent) {
    let result = true;
    if (typeof templateContent.fields.fileName.accept != 'undefined' && value != null) {
        let fileExt = value['name'].replace(/^.*\./, '');
        let accept = templateContent.fields.fileName.accept.replace(/^.*\./, '');
        if (fileExt !== 'undefined' && accept !== 'undefined') {
            let checkExtension = accept.indexOf(fileExt);
            result = checkExtension !== -1;
        }
    }
    return result;
}

function validateFileSizeInput(value, templateContent) {
    let result = true;
    if (typeof templateContent.fields.fileName.maxSize != 'undefined' && value != null) {
        let allowedSize = templateContent.fields.fileName.maxSize;
        let currentSize = value['size'];
        if (currentSize > allowedSize) {
            result = false;
        }
    }
    return result;
}

function checkPasswordSafe(value, templateContent, field, caller, rules) {
    let data = {
        function: 'passwordSafe',
        searchID: templateContent.valueLine['n_id'],
        responseType: 'ajax',
    };
    return checkSendRemote(templateContent.tableUrl, data, field, rules, value, caller);
}

function checkUserExists(value, templateContent, field, caller) {
    if (value !== '') {
        let data = {
            function: 'checkUserExists',
            searchID: templateContent.valueLine['n_id'],
            responseType: 'ajax',
        };
        data[field] = value;
        requests.frameworkAxiosRequest({
            method: 'POST',
            url: templateContent.tableUrl,
            dataType: 'json',
            data: data,
        })
            .then(response => {
                caller.errors = [];
                if (response.data.result.json != null && response.data.result.json !== 'true') {
                    caller.errors.push(response.data.result.json);
                }
            })
            .catch(error => {
                console.log(error);
            });
        return true;
    } else {
        return true;
    }
}

function checkErrors(rules, value) {
    let errors = [];
    rules.forEach((rule, index) => {
        if (index < rules.length - 1) {
            let text = rule(value);
            if (typeof text == 'string') {
                errors.push(text);
            }
        }
    });
    return errors;
}

function checkEmail(value, templateContent, field, caller, rules) {
    if (typeof value != 'undefined') {
        let errors = checkErrors(rules, value);
        if (errors.length === 0) {
            const validRegex = /\S+@\S+\.\S+/;
            if (validRegex.test(value)) { //basic format of email!
                let data = {
                    function: 'checkEmailFormat',
                    responseType: 'ajax',
                };
                return checkSendRemote(templateContent.tableUrl, data, field, rules, value, caller);
            } else {
                return false;
            }
        } else {
            return true;
        }
    }
    return true;
}

function checkUniqueEmail(value, templateContent, field, caller, rules) {
    console.log(caller.errors);
    if (typeof value != 'undefined') {

        let errors = checkErrors(rules, value);
        if (errors.length === 0) {
            const validRegex = /\S+@\S+\.\S+/;
            if (validRegex.test(value)) { //basic format of email!

                let data = {
                    function: 'checkUniqueEmail',
                    responseType: 'ajax',
                    searchID: templateContent.valueLine['n_id'],
                };
                return checkSendRemote(templateContent.tableUrl, data, field, rules, value, caller);
            } else {

                return false;
            }
        } else {
            return true;
        }

    }
    return true;
}

function checkSendRemote(url, data, field, rules, value, caller) {

    if (typeof value != 'undefined') {

        let errors = checkErrors(rules, value);

        if (errors.length === 0) {
            debounce(sendRemote, 500)(url, data, field, rules, value, caller);
        } else {
            return true;
        }
    }
    return true;
}

function sendRemote(url, data, field, rules, sentValue, caller) {
    let value = caller.value;
    if (caller.checkLoading) {
        return;
    }

    if (typeof value != 'undefined' && caller.previousValue !== value) {
        caller.previousValue = value;

        caller.checkLoading = true;

        data[field] = value;
        requests.frameworkAxiosRequest({
            method: 'POST',
            url: url,
            dataType: 'json',
            data: data,
        })
            .then(response => {
                caller.checkLoading = false;
                caller.errors = [];
                caller.previousErrors = [];
                if (response.data.result.json != null && response.data.result.json !== 'true') {

                    if (value === caller.value) {

                        caller.errors.push(response.data.result.json);
                        caller.previousErrors = caller.errors;
                    } else {
                        console.log('recalling');

                        sendRemote(url, data, field, rules, sentValue, caller);
                    }
                }
            })
            .catch(error => {
                caller.checkLoading = false;
                console.log(error);
            });
    } else {
        caller.checkLoading = false;
        caller.errors = caller.previousErrors;
    }
}

function checkUnique(value, templateContent, field, caller, rules) {
    let data = {
        function: 'unique',
        searchID: templateContent.valueLine['n_id'],
        responseType: 'ajax',
    };
    return checkSendRemote(templateContent.tableUrl, data, field, rules, value, caller);
}

function vendorUniqueDomain(value, templateContent, field, caller, rules) {
    if (typeof templateContent.valueLine.n_vendor != 'undefined' && templateContent.valueLine.n_vendor != null &&
        templateContent.valueLine.n_vendor !== 0 && value !== '') {

        let data = {
            function: 'vendorUniqueDomain',
            vendorValue: templateContent.valueLine.n_vendor,
            searchID: templateContent.valueLine.n_id,
            n_attrId: value,
            responseType: 'ajax',

        };
        return checkSendRemote(templateContent.tableUrl, data, field, rules, value, caller);
    } else {
        return true;
    }
}

function checkTypeMaxValue(value, templateContent) {
    if (typeof templateContent.valueLine != 'undefined' && typeof templateContent.valueLine.content != 'undefined' &&
        typeof templateContent.valueLine.type != 'undefined') {
        if (templateContent.valueLine.type === 'avgDeliveredPct' && value >
            templateContent.fields.content.AvgMaxNumber) {
            return false;
        }
    }
    return true;
}

function uniqueOrganisation(value, templateContent, field, caller, rules) {

    let data = {
        function: 'uniqueOrganisation',

        searchID: templateContent.valueLine.n_id,
        c_email: value,
        responseType: 'ajax',
    };
    return checkSendRemote(templateContent.tableUrl, data, field, rules, value, caller);
}


const callTagValidation = (value,caller) => {
    debounceCallTagSyntax(value,caller);
    return true;
};
const debounceCallTagSyntax =  debounce(async (value,caller) => {
    if(value){
        try {
             await simService.v2.countSimByTagQuery(value);
          } catch (err) {
            caller.errors = capitalize(err.message.trim());
            //console.log(err);
        }
    }
},700);

function validateCases(value, templateContent) {
    let valueArray = arrayFindInArray(templateContent.fields.attribute.value,
        templateContent.fields.attribute.associatedOption);
    let type = valueArray[2];
    let suppressed = false;
    if (typeof value != 'undefined' && value.indexOf('${') > -1) {
        //is a variable. dont validate
        return true;
    }
    if (typeof type != 'undefined' && suppressed !== true) {
        if (type === 'integer') {
            if (!isNumeric(value)) {

                return fieldErrorMesseages.notAnumber;
            }

        }
        if (type === 'Unsigned32') {
            if (!isNumeric(value) || value < 0 || value > 4294967295) {

                return fieldErrorMesseages.notUnsigned32;

            }

        } else if (type === 'short') {
            if (!isNumeric(value) || value > 65535) {
                return fieldErrorMesseages.notShort;

            }
        } else if (type === 'ipaddr' || type === 'IPAddress') {
            if (!validateIPV4andIPV6(value)) {
                return fieldErrorMesseages.invalidIPV4IPV6;
            }
        } else if (type === 'HexString') {
            if (!validateHex(value)) {
                return fieldErrorMesseages.hexString;
            }

        } else if (type === '16ByteHex') {
            let ishex = validateHex(value);
            if (!ishex) {
                return fieldErrorMesseages.hexString;

            } else {
                value = value.replaceAll(' ', '');
                if (value.length > 32) {
                    return 'must be less or equal to 32 digits';

                }
            }
        } else if (type === '14ByteHex') {
            let ishex = validateHex(value);
            if (!ishex) {
                return fieldErrorMesseages.hexString;

            } else {
                value = value.replaceAll(' ', '');
                if (value.length > 28) {
                    return 'must be less or equal to 28 digits';

                }
            }
        } else if (type === '8BitInt') {
            if (!isNumeric(value) || value < 0 || value > 255) {

                return fieldErrorMesseages.a8BitInt;

            }
        } else if (type === '16BitInt') {
            if (!isNumeric(value) || value < 0 || value > 65535) {

                return fieldErrorMesseages.a16BitInt;

            }
        } else if (type === 'NoValue|5ByteHex') {
            let ishex = validateHex(value);
            if (!ishex) {
                return fieldErrorMesseages.hexString;

            } else {
                value = value.replaceAll(' ', '');
                if (value.length > 10) {
                    return 'must be less or equal to 10 digits';

                }
            }
        }
    }
    return true;
}


function checkConfirmPassCode(n, templateContent) {
    let result = false;
    if (typeof templateContent.valueLine.c_password != 'undefined' && templateContent.valueLine.c_password === n) {
        result = true;
    }
    return result;
}

function passwordControl(n) { // future may come more conditions!
    let result = false;
    if (typeof n != 'undefined' && n.length > 7) {
        result = true;
    }
    return result;
}

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function validateCleanCondition(testCondition) {
    let assignedVariables = testCondition.split(/ && | AND | OR | \|\| /);
    let result = 'TRUE';
    assignedVariables.forEach(function (variable) {

        let singleConditionMatch = variable.match(
            /^(\$\{[A-Za-z\d:]+}|'.+?')\s(=~|!~|==|>|>=|!=|<|<=)\s(\$\{[A-Za-z\d]+}|'.+?')\s*$/);
        if (singleConditionMatch != null) {
            if ((singleConditionMatch[1].match(/'/g) || []).length > 2 || (singleConditionMatch[3].match(
                /'/g) || []).length > 2) {
                // more that 2 qoute in the match- condition is wrong
                result = 'FALSE';
            }
        } else {
            variable = variable.trim();
            if (!(variable === '' || variable === 'TRUE')) {
                result = 'FALSE';
            }
        }
    });
    return result;
}

function cleanNestedCondition(testCondition) {
    let check;
    // get last opening
    let insideNot = null;
    let lastMatch = null;
    let location = 0;
    do {
        insideNot = testCondition.substring(location).match(/(!|not)?\(/);
        if (insideNot != null) {
            lastMatch = insideNot;
            location += lastMatch.index + lastMatch[0].length;
        }

    } while (insideNot != null);
    if (lastMatch != null) {
        let closingIndex = testCondition.indexOf(')', location);
        // if found search for the next opening or the closing
        if (closingIndex > -1) {
            let firstPart = testCondition.substring(0, location - 1);
            if (firstPart === '!' || firstPart === 'not') {
                firstPart = '';
            }
            //break down string and validate
            let nextsubstring = testCondition.substring(location, closingIndex);
            nextsubstring = validateCleanCondition(nextsubstring);

            let lastsubstring = testCondition.substring(closingIndex + 1);
            testCondition = firstPart + nextsubstring + lastsubstring;
            check = cleanNestedCondition(testCondition);
        } else {
            check = false;
        }

    } else {
        check = validateCleanCondition(testCondition);
    }
    return check;
}

function validateIPV6(value) {
    const ip = /^\s*((([\dA-Fa-f]{1,4}:){7}([\dA-Fa-f]{1,4}|:))|(([\dA-Fa-f]{1,4}:){6}(:[\dA-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([\dA-Fa-f]{1,4}:){5}(((:[\dA-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([\dA-Fa-f]{1,4}:){4}(((:[\dA-Fa-f]{1,4}){1,3})|((:[\dA-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([\dA-Fa-f]{1,4}:){3}(((:[\dA-Fa-f]{1,4}){1,4})|((:[\dA-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([\dA-Fa-f]{1,4}:){2}(((:[\dA-Fa-f]{1,4}){1,5})|((:[\dA-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([\dA-Fa-f]{1,4}:)(((:[\dA-Fa-f]{1,4}){1,6})|((:[\dA-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[\dA-Fa-f]{1,4}){1,7})|((:[\dA-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
    let match = ip.test(value);
    return value === '' || match;
}

function validateIPV6WithProtocol(value) {
    let baseIpCheck = /((([\dA-Fa-f]{1,4}:){7}([\dA-Fa-f]{1,4}|:))|(([\dA-Fa-f]{1,4}:){6}(:[\dA-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([\dA-Fa-f]{1,4}:){5}(((:[\dA-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([\dA-Fa-f]{1,4}:){4}(((:[\dA-Fa-f]{1,4}){1,3})|((:[\dA-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([\dA-Fa-f]{1,4}:){3}(((:[\dA-Fa-f]{1,4}){1,4})|((:[\dA-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([\dA-Fa-f]{1,4}:){2}(((:[\dA-Fa-f]{1,4}){1,5})|((:[\dA-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([\dA-Fa-f]{1,4}:)(((:[\dA-Fa-f]{1,4}){1,6})|((:[\dA-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[\dA-Fa-f]{1,4}){1,7})|((:[\dA-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?/;
    const ip = new RegExp(/^\s*/.source + baseIpCheck.source + /\s*$/.source);
    const ipWithProtocol = new RegExp(
        /^\s*((http:\/\/|https:\/\/)?)?\[/.source + baseIpCheck.source + /](:\d{1,5})?(\/.*)?\s*$/.source);

    let match = ip.test(value) || ipWithProtocol.test(value);
    return value === '' || match;
}

function validateJsonPath(value) {
    if (value === '' || value === '$.') return true;
    try {
        jsonpath.query({}, value);
        return true;
    } catch (e) {
        return false;
    }
}

function validateXPath(value) {
    try {
        document.evaluate(value, document, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
        return true;
    } catch (e) {
        return false;
    }
}

function validateVariable(value) {
    let regex = /^\$\{(.*)}$/;
    return value === '' || value.match(regex) != null;
}

function validateURI(value) {
    // check if the given string is a valid URI
    //Arguments
    //value to be  validated
    // return true or false
    // called by addValidatorMethods
    if (typeof value == 'undefined') {
        value = '';
    }
    const domain = /^([a-z]([a-z]|\d|\+|-|\.)*):(\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:)*@)?((\[(|(v[\da-f]{1,}\.(([a-z]|\d|-|\.|_|~)|[!$&'()*+,;=]|:)+))])|((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=])*)(:\d*)?)(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)*)*|(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)*)*)?)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)*)*)|(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@){0})(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|\/|\?)*)?$/i;
    return value === '' || value.match(domain) != null;
}

function validateMSISDNCustomerID(value) {
    const MSISDN = /^\d+$/;
    const CID = /^(\d+)#([A-Z])/i;
    return value.match(MSISDN) != null || value.match(CID) != null;
}

function numericAndDotAllowed(value) {
    return value.match(/^[\d.-]+$/) != null;
}

function validateDomainNameOnly(value) {
    const domain = /^(?:[a-zàáâãäåæāăąçćĉċčďđèéêëēĕėęěĝğġģĥħìíîïĩīĭįıðĵķĸĺļľłñńņňŋòóôõöøōŏőœŕŗřśŝşšţťŧùúûüũūŭůűųŵýŷÿźżžþßŀŉșțΐάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώабвгдежзийклмнопрстуфхцчшщъыьэюяἀἁἂἃἄἅἆἇἐἑἒἓἔἕἠἡἢἣἤἥἦἧἰἱἲἳἴἵἶἷὀὁὂὃὄὅὐὑὒὓὔὕὖὗὠὡὢὣὤὥὦὧὰὲὴὶὸὺὼᾀᾁᾂᾃᾄᾅᾆᾇᾐᾑᾒᾓᾔᾕᾖᾗᾠᾡᾢᾣᾤᾥᾦᾧᾰᾱᾲᾳᾴᾶᾷῂῃῄῆῇῐῑῒῖῗῠῡῢῤῥῦῧῲῳῴῶῷ\d](?:[a-zàáâãäåæāăąçćĉċčďđèéêëēĕėęěĝğġģĥħìíîïĩīĭįıðĵķĸĺļľłñńņňŋòóôõöøōŏőœŕŗřśŝşšţťŧùúûüũūŭůűųŵýŷÿźżžþßŀŉșțΐάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώабвгдежзийклмнопрстуфхцчшщъыьэюяἀἁἂἃἄἅἆἇἐἑἒἓἔἕἠἡἢἣἤἥἦἧἰἱἲἳἴἵἶἷὀὁὂὃὄὅὐὑὒὓὔὕὖὗὠὡὢὣὤὥὦὧὰὲὴὶὸὺὼᾀᾁᾂᾃᾄᾅᾆᾇᾐᾑᾒᾓᾔᾕᾖᾗᾠᾡᾢᾣᾤᾥᾦᾧᾰᾱᾲᾳᾴᾶᾷῂῃῄῆῇῐῑῒῖῗῠῡῢῤῥῦῧῲῳῴῶῷ\d-]{0,61}[a-zàáâãäåæāăąçćĉċčďđèéêëēĕėęěĝğġģĥħìíîïĩīĭįıðĵķĸĺļľłñńņňŋòóôõöøōŏőœŕŗřśŝşšţťŧùúûüũūŭůűųŵýŷÿźżžþßŀŉșțΐάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώабвгдежзийклмнопрстуфхцчшщъыьэюяἀἁἂἃἄἅἆἇἐἑἒἓἔἕἠἡἢἣἤἥἦἧἰἱἲἳἴἵἶἷὀὁὂὃὄὅὐὑὒὓὔὕὖὗὠὡὢὣὤὥὦὧὰὲὴὶὸὺὼᾀᾁᾂᾃᾄᾅᾆᾇᾐᾑᾒᾓᾔᾕᾖᾗᾠᾡᾢᾣᾤᾥᾦᾧᾰᾱᾲᾳᾴᾶᾷῂῃῄῆῇῐῑῒῖῗῠῡῢῤῥῦῧῲῳῴῶῷ\d])?\.)+[a-zàáâãäåæāăąçćĉċčďđèéêëēĕėęěĝğġģĥħìíîïĩīĭįıðĵķĸĺļľłñńņňŋòóôõöøōŏőœŕŗřśŝşšţťŧùúûüũūŭůűųŵýŷÿźżžþßŀŉșțΐάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώабвгдежзийклмнопрстуфхцчшщъыьэюяἀἁἂἃἄἅἆἇἐἑἒἓἔἕἠἡἢἣἤἥἦἧἰἱἲἳἴἵἶἷὀὁὂὃὄὅὐὑὒὓὔὕὖὗὠὡὢὣὤὥὦὧὰὲὴὶὸὺὼᾀᾁᾂᾃᾄᾅᾆᾇᾐᾑᾒᾓᾔᾕᾖᾗᾠᾡᾢᾣᾤᾥᾦᾧᾰᾱᾲᾳᾴᾶᾷῂῃῄῆῇῐῑῒῖῗῠῡῢῤῥῦῧῲῳῴῶῷ\d][a-zàáâãäåæāăąçćĉċčďđèéêëēĕėęěĝğġģĥħìíîïĩīĭįıðĵķĸĺļľłñńņňŋòóôõöøōŏőœŕŗřśŝşšţťŧùúûüũūŭůűųŵýŷÿźżžþßŀŉșțΐάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώабвгдежзийклмнопрстуфхцчшщъыьэюяἀἁἂἃἄἅἆἇἐἑἒἓἔἕἠἡἢἣἤἥἦἧἰἱἲἳἴἵἶἷὀὁὂὃὄὅὐὑὒὓὔὕὖὗὠὡὢὣὤὥὦὧὰὲὴὶὸὺὼᾀᾁᾂᾃᾄᾅᾆᾇᾐᾑᾒᾓᾔᾕᾖᾗᾠᾡᾢᾣᾤᾥᾦᾧᾰᾱᾲᾳᾴᾶᾷῂῃῄῆῇῐῑῒῖῗῠῡῢῤῥῦῧῲῳῴῶῷ\d-]{0,61}[a-zàáâãäåæāăąçćĉċčďđèéêëēĕėęěĝğġģĥħìíîïĩīĭįıðĵķĸĺļľłñńņňŋòóôõöøōŏőœŕŗřśŝşšţťŧùúûüũūŭůűųŵýŷÿźżžþßŀŉșțΐάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώабвгдежзийклмнопрстуфхцчшщъыьэюяἀἁἂἃἄἅἆἇἐἑἒἓἔἕἠἡἢἣἤἥἦἧἰἱἲἳἴἵἶἷὀὁὂὃὄὅὐὑὒὓὔὕὖὗὠὡὢὣὤὥὦὧὰὲὴὶὸὺὼᾀᾁᾂᾃᾄᾅᾆᾇᾐᾑᾒᾓᾔᾕᾖᾗᾠᾡᾢᾣᾤᾥᾦᾧᾰᾱᾲᾳᾴᾶᾷῂῃῄῆῇῐῑῒῖῗῠῡῢῤῥῦῧῲῳῴῶῷ\d]$/;
    return value === '' || value.toLowerCase().match(domain) != null;
}

function validateHex(value) {
    return !!(typeof value == 'undefined' || value.match(/^([A-Fa-f\d][A-Fa-f\d]( )*)*$/));
}

function validateNewCaptcha(val) {
    return val === 'loaded';
}

function checkRegexVariable(value) {
    let isValid = true;
    try {
        new RegExp(value);
    } catch (e) {
        isValid = false;
    }
    return isValid;
}

function testConditionInputChecker(value) {
    if (typeof value != 'undefined') {
        let check = cleanNestedCondition(value.trim());
        if (check === true || check === 'TRUE') {
            return true;
        }
    }
}

function MSISDNChecker(value) {
    const numberLength = value.length;
    const avoid = ['000', '+00'];
    const avoidThree = ['000', '+00', '+'];
    const pattern = '^(\\+)?(\\d+)$';
    const checkPlus = '^\\+\\d*$';

    if (numberLength > 2) {
        const firstThree = value.substring(0, 3);
        if ((numberLength === 3 && value.match(checkPlus)) || avoidThree.indexOf(value) === 0) {
            return false;
        } else {
            if (value.match(pattern)) {
                return avoidThree.indexOf(firstThree) < 0;
            } else {
                return false;
            }
        }
    } else {
        if (avoid.indexOf(value) >= 0) {
            return true;
        }
    }
    return false;
}

function fullNameCheckFunction(value) {
    value = value.trim();
    let index = value.lastIndexOf(' ');
    let firstName = value.substring(0, index);
    let lastName = value.substring(index);
    if (firstName === '' || lastName === '') {
        return false;
    } else return !(firstName.length > 100 || lastName.length > 100);
}

function plusNotFollowedByZero(value) {
    const pattern = '^\\+(?!\\s*0+)'; // plus cant be followed by 0
    return !!(value === '' || value.match(pattern) || !value.match('^\\+'));
}

function plusPhoneChecker(value) {
    const pattern = '^\\+[\\d\\s]+$'; // it must be add plus infront of number and it cant be followed by 0 and should be followed with atleast one digit
    return !!(typeof value == 'undefined' || value === '' || value.match(pattern) || (value.match('^\\d*$')));
}

function notOnlyNumberChecker(value) {
    if (typeof value == 'undefined') {
        value = '';
    }
    if (typeof value != 'undefined') {
        return !(value !== '' && value.match(/^\d+$/));
    }
}

function getRuleForPossibleUnits(possibleUnits) {
    if (possibleUnits && possibleUnits.length) {
        const microIndex = possibleUnits.indexOf('µs');
        let exampleUnit = possibleUnits[0];
        if (exampleUnit === 'µs') exampleUnit = 'us';
        const errorString = `Invalid value format. Possible units are: ${possibleUnits.join(', ')
            .replace('µs', 'us (µs)')}. Example: 5${exampleUnit}`;
        if (microIndex >= 0) {
            possibleUnits.push('us');
        }
        const pattern = `^\\d+(${possibleUnits.join('|')})$`;
        return v => new RegExp(pattern).test(v) || errorString;
    }
    return true;
}

function validateHexByte(value) {
    value = parseInt(value, 16);
    if (isNaN(value)) return false;
    return value >= 0 && value <= 255;
}

function getRequiredRule() {
    return v => !!v || 'This field is required.';
}

function getHexByteRule() {
    return v => validateHexByte(v) || 'Value must be between 0x00 and 0xff.';
}


const PING_MIN_MICROSEC = 100;
const PING_MAX_SEC = 600;
const PING_MAX_MICROSEC = secToMicrosec(PING_MAX_SEC);

function getPingIntervalRule() {
    return v => validatePingInterval(v) || `Value must be >= ${PING_MIN_MICROSEC}µs and <= ${PING_MAX_SEC}s.`;
}

function validatePingInterval(value) {
    if (!value) return false;

    const valueMatches = value.toString().match(/\d+(?=[smuµ])/);
    const unitMatches = value.match(/(?!\d)[smuµ]+/);

    if (!valueMatches || !unitMatches) return false;
    value = valueMatches[0];
    const unit = unitMatches[0];

    value = parseInt(value);
    if (unit === 's') {
        value = secToMicrosec(value);
    } else if (unit === 'ms') {
        value = millisecToMicrosec(value);
    } else if (unit !== 'us' && unit !== 'µ') {
        return false;
    }

    return value >= PING_MIN_MICROSEC && value <= PING_MAX_MICROSEC;
}

function validateDomain(value) {
    // check if the given string is a valid domain name
    //Arguments
    //value to be  validated
    // return true or false
    // called by addValidatorMethods
    const domain = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z\d]+([-.][a-z\d]+)*\.[a-z]{2,5}(:[\d]{1,5})?(\/.*)?$/;
    return !value || value === '' || value.match(domain) != null;
}

function validateSpecialDomain(value) { // Arnold.has.new.Regix
    const domain = /^[a-z0-9-_]+\.([a-z0-9-_]+\.)?([a-z0-9-_]+\.)?[a-z]+$/;
    return !value || value === '' || value.match(domain) != null;
}

function validateIPV4andIPV6(value) {
    if (typeof value == 'undefined') {
        value = '';
    }
    let check;
    const ip = '((^\\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\\s*$)|(^\\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:)(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))(%.+)?\\s*$))';
    check = value === '' || value.match(ip) != null;
    return check;
}

function validateIP(value) {
    // function to validate the ip
    //Arguments
    //value to be  validated
    // return true or false
    // called by addValidatorMethods
    // console.log(value)
    if (typeof value == 'undefined') {
        value = '';
    }
    const ip = '^([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])$';
    return value === '' || value.match(ip) != null;
}

function validateSIP(value) {
    console.log(value);
    if (typeof value == 'undefined') {
        value = '';
    }
    const sip = '^(sip\\:[a-zA-z0-9\\-.]+\\@([a-zA-z0-9\\-.].){1,10}[a-zA-z0-9\\-])$';
    return value === '' || value.match(sip) != null;
}


function validateIPWithProtocol(value) {
    if (typeof value == 'undefined') {
        value = '';
    }
    const ip = '^((http://|https://|http://|https://)?){0,1}([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])(:[0-9]{1,5}){0,1}(/.*)?$';
    return value === '' || value.match(ip) != null;
}

function getPortRule() {
    return v => validatePort(v) || 'Ports can only be an integer value from 1 to 65535.';
}

function validatePort(value) {
    const port = parseInt(value);
    return port && port >= 1 && port <= 65535;
}

export function validateLatitude(value) {
  const MIN = -90;
  const MAX = 90;
  let v = value
  if (typeof v === 'string') {
    v = parseFloat(value);
  }

  return !Number.isNaN(v) && v >= MIN && v <= MAX;
}

export function validateLongitude(value) {
  const MIN = -180;
  const MAX = 180;
  let v = value
  if (typeof v === 'string') {
    v = parseFloat(value);
  }

  return !Number.isNaN(v) && v >= MIN && v <= MAX;
}

export {
    getCheckboxRules, getSelectRules, getRules,
};
